import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import '../assets/styles/Home.css';
import NavBar from "../components/NavBar";
import Logo from '../assets/images/logoTransparent.png';
import SnP500Ret from '../assets/images/AvgSnP500Ret.png';
import Footer from '../components/Footer';

const Home = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Map special entry routes to a source label
    const routeToSource = {
        '/linkedin': 'linkedin',
        '/instagram': 'instagram',
        '/youtube': 'youtube',
        '/x': 'x',
    };

    useEffect(() => {
        // Avoid duplicate logs within same session (global home flag)
        if (sessionStorage.getItem('home_visit_logged')) {
            // Normalize URL if on a source route even if already logged
            if (routeToSource[location.pathname]) {
                navigate('/', { replace: true });
            }
            return;
        }

        const sessionKey = `logged_${location.pathname}`;
        if (sessionStorage.getItem(sessionKey)) return;

        const source = routeToSource[location.pathname] || null;

        // Always log as visit to /home, capturing source if applicable
        fetch(`${process.env.REACT_APP_API_URL}/logPageVisit`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ page: '/home', source })
        }).catch(() => {});

        sessionStorage.setItem(sessionKey, '1');
        sessionStorage.setItem('home_visit_logged', '1');

        // If they landed on a source route, normalize URL to root after logging
        if (source) {
            navigate('/', { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    
    return (
        <>
        <NavBar onSectionClick={scrollToSection} />

        <div className="homepage">
            <img src={Logo} alt='finntechLogo' className='homeLogo' />
            <h3 className="slogan">Invest Smarter, Not Harder</h3>
            <div className='buttons'>
                <Link className='btn' to="/login">Login</Link>
                <Link className='btn' to="/signup">Sign Up</Link>
            </div>
            <img src={SnP500Ret} alt='homepageGraph' className='SnP500Img' />
        </div>
        <hr/>
        <div id="about">
            <h1 className='abouth1'>About</h1>
            <h4 className='aboutbody'>FinnTech is a service that empowers its users to learn, monitor, and organize the financial information that is relevant to them. It does this primarily by offering a customizable dashboard made of a selection of different financially relevant charts and graphs, as well as offering other learning resources such as book/podcast recommendations, a beginner’s guide to getting started with managing and planning your finances, and a backlog of informational videos.</h4>
        </div>
        <hr/>
        <div id="social-media">
            <h1 className='abouth1'>Social Media</h1>
            <div className="home-social-media">
                <a href="https://www.youtube.com/@TheFinnTech" target="_blank" rel="noopener noreferrer">
                    <img src="/youtube-icon.png" alt="YouTube" />
                </a>
                <a href="https://www.linkedin.com/company/finn-tech-llc/" target="_blank" rel="noopener noreferrer">
                    <img src="/linkedin-icon.png" alt="LinkedIn" />
                </a>
                <a href="https://x.com/TheFinnTech" target="_blank" rel="noopener noreferrer">
                    <img src="/x-social-media-logo-icon.webp" alt="X" />
                </a>
                <a href="https://www.instagram.com/thefinntech/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src="/instagram.webp" alt="Instagram" />
                </a>
            </div>
        </div>
        <div>
            <Footer/>
        </div>

        </>
    );
};
    
export default Home;